import misRutas from 'vue-routes-generator'
import ProduccionComponent from './App'

export default {
	install: Vue => {
		misRutas.route('/main').child('produccion', {
			name: 'Producción',
			component: ProduccionComponent
		})

		misRutas.route('/main').child('produccion/:seccion/:TareaID', {
			name: 'Vista de tarea',
			component: ProduccionComponent
		})

		misRutas.route('/main').child('produccion/:seccion', {
			name: 'Sección de producción',
			component: ProduccionComponent
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/produccion/vue/index.js